/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJs, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { PropTypes } from 'prop-types';

ChartJs.register(ArcElement, Tooltip, Legend, ChartDataLabels);

function PieChart({ chartData, chartName }) {
	// console.log('chartData ', chartData);
	function getGradient(chart, colors = { color1: '#D96381', color2: '#FD8AA7' }) {
		const {
			ctx,
			chartArea: { left, right },
			// chartArea: { top, bottom, left, right },
		} = chart;
		// console.log('top ', top);
		// console.log('bottom ', bottom);
		// xs, ys, xe, ye = xs(x start) xe(x end)
		const gradientSegment = ctx.createLinearGradient(left, 0, right, 0);
		gradientSegment.addColorStop(0, colors.color1);
		gradientSegment.addColorStop(1, colors.color2);
		return gradientSegment;
	}

	const [userData, setUserData] = useState();

	const options = {
		tooltips: {
			enabled: false,
		},
		plugins: {
			datalabels: {
				formatter: (value, ctx) => {
					let sum = 0;
					const dataArr = ctx.chart.data.datasets[0].data;
					// eslint-disable-next-line no-return-assign
					dataArr.forEach((data) => (sum += data));
					return `${Math.round((value * 100) / sum)}%`;
				},
				legend: {
					display: true,
					labels: {
						color: 'rgb(255, 99, 132)',
					},
				},
				color: 'white',
				font: {
					size: '23%',
					weight: 500,
				},
			},
		},
	};

	useEffect(() => {
		setUserData({
			// labels: chartData.map((data) => data.year),
			labels: false,
			datasets: [
				{
					label: ' Total Trips ',
					data: chartData.map((data) => data.completed),
					backgroundColor: (context) => {
						// console.log('context ', context);
						const charts = context.chart;
						const { ctx, chartArea } = charts;
						if (ctx) {
							// console.log('ctx ', ctx);
						}
						if (!chartArea) {
							return null;
						}
						if (context.dataIndex === 0) {
							// console.log('getGradient ', getGradient(charts));
							return chartName === 'adhoc'
								? getGradient(charts, {
										color1: '#D96381',
										color2: '#FD8AA7',
								  })
								: getGradient(charts, {
										color1: '#B0A3FF',
										color2: '#553AF7',
								  });
						}
						if (context.dataIndex === 1) {
							return getGradient(charts);
							// console.log('getGradient ', getGradient(charts));
						}
						return 'red';
					},
				},
			],
		});
	}, [chartData, chartName]);
	// console.log('userData ', userData);
	return userData && <Pie options={options} data={userData} />;
}

PieChart.propTypes = {
	chartData: PropTypes.any,
	chartName: PropTypes.string,
};

export default PieChart;
